const apiConfig = {
    name: "aberdeen-cleaning-api",
    endpoint: "https://2wj4ropc3l.execute-api.eu-west-2.amazonaws.com",
    env: "prod",
};

export default apiConfig;
